import { createFileRoute } from '@tanstack/react-router'
import { ClinicDeletePage } from '@/features/clinics/delete'

export const Route = createFileRoute('/clinics_/$clinicId/delete')({
  component: RouteComponent,
})

function RouteComponent() {
  const { clinicId } = Route.useParams()
  return <ClinicDeletePage clinicId={clinicId} />
}
